import type { Vec3 } from "@models/data/entityData";

/**
 * Renderer-side geometry seam for Unity's vertex-accurate floor placement.
 * The headless model owns persistence; the viewport owns rendered bounds and
 * converts the world-space drop back into snapshot-local coordinates.
 */
export interface IPlacementGeometryHost {
  calculateGroundedPosition(sceneId: string, snapshotId: string): Vec3 | null;
}

export interface IPlacementModel {
  attachGeometryHost(host: IPlacementGeometryHost | null): void;
  placeOnGroundAsync(sceneId: string, snapshotId: string): Promise<void>;
  resetPositionAsync(sceneId: string, snapshotId: string): Promise<void>;
  resetRotationAsync(sceneId: string, snapshotId: string): Promise<void>;
  resetTransformAsync(sceneId: string, snapshotId: string): Promise<void>;
  resetScaleAsync(sceneId: string, snapshotId: string): Promise<void>;
  alignToCadOriginsAsync(sceneId: string, snapshotId: string): Promise<void>;
}

export const PLACEMENT_MODEL = Symbol.for("Campfire.PlacementModel");
